import { render } from "./HeroiconsSolidUserGroup.vue?vue&type=template&id=aba846c2"
const script = {}

import exportComponent from "/Users/taylor/Documents/Code/laravel-nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidUserGroup.vue"]])

export default __exports__